export const waitForElement = (selector, timeout) => new Promise((resolve, reject) => {
    if (document.querySelector(selector)) {
        return resolve(document.querySelector(selector));
    }
    if (timeout)
        setTimeout(() => reject(), timeout);
    const observer = new MutationObserver(() => {
        if (document.querySelector(selector)) {
            observer.disconnect();
            resolve(document.querySelector(selector));
        }
    });
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
});
//# sourceMappingURL=dom.js.map